// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import { fetchWrapper, postWrapper } from 'helpers/api/meta'

export const fetchSyncCaseStatuses = () => (
  [{
    caseStatus: 'Clear',
    coordinationTrackerCaseStatusId: '1',
  }, {
    caseStatus: 'Pending',
    coordinationTrackerCaseStatusId: '2',
  }, {
    caseStatus: 'Sent',
    coordinationTrackerCaseStatusId: '3',
  }] ||
  fetchWrapper('/case-statuses')
)

export const fetchProtectionProjectByRcn = rcnNumber => (
  fetchWrapper(`/protection-projects/get-project-by-rcn/${rcnNumber}`)
)

export const fetchProtectionProjectSyncCaseCounts = projectId => (
  fetchWrapper(`/protection-projects/${projectId}/sync-cases`)
)

export const postSyncProtectionProjectCases = (projectId, caseDataToSync) => (
  postWrapper(
    `/protection-projects/${projectId}/sync-cases/submit`,
    caseDataToSync
  )
)
